import React from 'react';
import { FaUser, FaUserTie, FaUtensils, FaGlassWhiskey, FaClock, FaEdit } from 'react-icons/fa';
import './EmployeeCard.css';

const EmployeeCard = ({ employee, onClick, schedule }) => {
  // Fonction pour convertir le rôle en français
  const getRoleInFrench = (role) => {
    switch (role) {
      case 'server':
        return 'Serveur';
      case 'cook':
        return 'Cuisinier';
      case 'bar':
        return 'Barman';
      default:
        return role;
    }
  };

  // Fonction pour obtenir l'icône du rôle
  const getRoleIcon = (role) => {
    switch (role) {
      case 'server':
        return FaUserTie;
      case 'cook':
        return FaUtensils;
      case 'bar':
        return FaGlassWhiskey;
      default:
        return FaUser;
    }
  };

  // Mapping des jours en anglais vers le français
  const dayMapping = {
    Monday: "Lundi",
    Tuesday: "Mardi",
    Wednesday: "Mercredi",
    Thursday: "Jeudi",
    Friday: "Vendredi",
    Saturday: "Samedi",
    Sunday: "Dimanche"
  };

  // L'ordre des jours de la semaine en français
  const daysOfWeek = [
    "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"
  ];

  const RoleIcon = getRoleIcon(employee.role);

  // Fonction pour obtenir la couleur du rôle
  const getRoleColor = (role) => {
    switch (role) {
      case 'server':
        return '#3b82f6';
      case 'cook':
        return '#f59e0b';
      case 'bar':
        return '#10b981';
      default:
        return '#6b7280';
    }
  };

  // Compter les jours de travail
  const workingDays = schedule ? daysOfWeek.filter(day => 
    schedule.schedule[day] && schedule.schedule[day] !== 'Ne travaille pas'
  ).length : 0;

  return (
    <div className="employee-schedule-card">
      <div className="employee-schedule-card-header">
        <div className="employee-schedule-avatar" style={{ backgroundColor: getRoleColor(employee.role) }}>
          <RoleIcon />
        </div>
        <div className="employee-schedule-info">
          <h3 className="employee-schedule-name">{employee.firstName} {employee.lastName}</h3>
          <div className="employee-schedule-role">
            <RoleIcon className="employee-schedule-role-icon" />
            <span>{getRoleInFrench(employee.role)}</span>
          </div>
        </div>
        <button 
          className="employee-schedule-edit-btn"
          onClick={(e) => {
            e.stopPropagation();
            onClick(employee, 'Monday');
          }}
        >
          <FaEdit />
        </button>
      </div>

      <div className="employee-schedule-stats">
        <div className="employee-schedule-stat">
          <FaClock className="employee-schedule-stat-icon" />
          <span className="employee-schedule-stat-value">{workingDays}</span>
          <span className="employee-schedule-stat-label">jours/semaine</span>
        </div>
      </div>

      <div className="employee-schedule-days">
        {schedule ? daysOfWeek.map((day) => {
          const scheduleText = schedule.schedule[day] || "Ne travaille pas";
          const isWorking = scheduleText !== "Ne travaille pas";
          
          return (
            <div 
              key={day} 
              className={`employee-schedule-day ${isWorking ? 'working' : 'not-working'}`}
              onClick={(e) => {
                e.stopPropagation();
                onClick(employee, day);
              }}
            >
              <div className="employee-schedule-day-name">{dayMapping[day]}</div>
              <div className="employee-schedule-day-hours">
                {isWorking ? scheduleText : 'Repos'}
              </div>
            </div>
          );
        }) : (
          <div className="employee-schedule-no-data">
            Aucun planning défini
          </div>
        )}
      </div>
    </div>
  );
};

export default EmployeeCard;
